import { render, staticRenderFns } from "./FeedsView.vue?vue&type=template&id=a39f152c&scoped=true&"
import script from "./FeedsView.vue?vue&type=script&lang=js&"
export * from "./FeedsView.vue?vue&type=script&lang=js&"
import style0 from "./FeedsView.vue?vue&type=style&index=0&id=a39f152c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39f152c",
  null
  
)

export default component.exports